export interface QueueConfig {
  redisHost?: string;
  redisPort?: number;
  redisPassword?: string;
  tls?: Record<PropertyKey, unknown>
  keyPrefix?: string;
}
export const QUEUE_CONFIG = 'QUEUE_CONFIG';